import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sukaTextArea]'
})

// tslint:disable-next-line: directive-class-suffix
export class TextArea {
  @HostBinding('class.text-area') baseClass = true;
  @HostBinding('class.text-area--invalid') @Input() invalid = false;
  @HostBinding('class.text-area--valid') @Input() valid = false;
  @HostBinding('class.skeleton') @Input() skeleton = false;
}
